import { memo } from 'react';

import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import type { RouteComponentProps } from 'react-router';
import { compose } from 'recompact';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { getOTCCopy } from 'src/app/components/Pages/PromotionalLandingPage/constants';
import { errorBoundary } from 'src/app/hocs';
import { checkProviderZipCode, checkZipCode } from 'src/app/router/paths';
import { redirectToOnboarding, segmentTrack, setShowFaqModal } from 'src/app/state/actions';
import { getCurrentPathParams, shouldShowFaqModal } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';
import { arePathnamesEqual, getLocationParams, standardizePathName } from 'src/app/utils';

import { PROMOTIONAL_PATH_TO_IMAGE_MAP } from './consts';

import { PromotionalRenderer } from '.';

type OwnProps = RouteComponentProps & {
  match: {
    params: {
      promo_code: string;
    };
  };
};

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  // @ts-ignore
  const pathname = standardizePathName(state.router.location.pathname);
  const pathParams = getLocationParams(getCurrentPathParams(state));

  const partnerName = ownProps.match?.params?.promo_code ?? pathParams['r'];
  const promoCode = ownProps.match?.params?.promo_code;

  const promoImageDetails = PROMOTIONAL_PATH_TO_IMAGE_MAP[partnerName];
  const isCheckZipPage = arePathnamesEqual(pathname, checkZipCode.toPath());
  const isProviderZipPage = arePathnamesEqual(pathname, checkProviderZipCode.toPath());
  const otcCopy = getOTCCopy();
  const isGetStartedCTA = otcCopy[partnerName]?.isGetStartedCTA ?? false;

  return {
    pathname,
    promoImageDetails,
    showFaqModal: shouldShowFaqModal(state),
    hasFaqModal: isCheckZipPage,
    isSimplePromoLayout: isCheckZipPage || isProviderZipPage,
    isGetStartedCTA,
    promoCode,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    dispatchSegmentTrack: (event: UnifiedEvent, payload: any = {}) => dispatch(segmentTrack(event, payload)),
    toggleShowFAQModal: (toggle: boolean) => dispatch(setShowFaqModal(toggle)),
    onRedirectToOnboarding: (referral?: string) =>
      dispatch(redirectToOnboarding('Promo Landing Page Sticky CTA', { referral })),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PromotionalPropsFromRedux = ConnectedProps<typeof connector>;

export const Promotional = compose(errorBoundary, connector, memo)(PromotionalRenderer);

Promotional.displayName = PromotionalRenderer.displayName;
